import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ArticleCard } from "../components/Cards";

export default function Articles() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data));
  }, []);

  return (
    <div data-testid="articles-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-32 pb-24">
      <div className="mb-16 reveal">
        <p className="eyebrow mb-4">Editorial</p>
        <h1 className="font-display text-6xl md:text-7xl mb-6">Essays & Reportage</h1>
        <p className="text-lg max-w-2xl leading-relaxed" style={{ color: "var(--ink-muted)" }}>
          Written slowly. Edited with care. Published only when finished.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
        {articles.map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>
    </div>
  );
}
